const urls = {
  base: '/about/',
};

export function aboutUrl() {
  return urls.base;
}

export default urls;